import { AfterViewChecked, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appCamelCaseText]'
})
export class CamelCaseTextDirective implements AfterViewChecked {
  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2
  ) {}

  ngAfterViewChecked(): void {
    const currentValue = this.elementRef.nativeElement.textContent ?? '';
    const formattedValue = CamelCaseTextDirective.toTitleCase(currentValue);

    if (formattedValue !== currentValue) {
      this.renderer.setProperty(this.elementRef.nativeElement, 'textContent', formattedValue);
    }

  }

  static toTitleCase(value: string | null | undefined): string {
    const normalizedValue = String(value ?? '').replace(/\s+/g, ' ').trim();
    if (!normalizedValue) return '';

    const lowercaseWords = new Set([
      'a',
      'as',
      'com',
      'da',
      'das',
      'de',
      'do',
      'dos',
      'e',
      'em',
      'na',
      'nas',
      'no',
      'nos',
      'o',
      'os',
      'para',
      'por'
    ]);

    return normalizedValue
      .split(' ')
      .map((word, index) => this.formatCompoundWord(word, index, lowercaseWords))
      .join(' ');
  }

  private static formatCompoundWord(word: string, index: number, lowercaseWords: Set<string>): string {
    return word
      .split('-')
      .map((part, partIndex) => this.formatWord(part, index + partIndex, lowercaseWords))
      .join('-');
  }

  private static formatWord(word: string, index: number, lowercaseWords: Set<string>): string {
    const normalizedWord = word.toLocaleLowerCase('pt-BR');

    if (index > 0 && lowercaseWords.has(normalizedWord)) {
      return normalizedWord;
    }

    if (/[A-Za-z]\./.test(word)) {
      return word.toLocaleUpperCase('pt-BR');
    }

    return normalizedWord.charAt(0).toLocaleUpperCase('pt-BR') + normalizedWord.slice(1);
  }
}
